export default __webpack_public_path__ + "static/media/jan2024-3.fbe1942c.jpg";